import { maskitoTransform, type MaskitoOptions } from "@maskito/core";
import {
  maskitoDateOptionsGenerator,
  maskitoWithPlaceholder,
} from "@maskito/kit";

import { YearlessDateMode } from "../../types";
import { makeZeroShortcutPreprocessor } from "../../../DateFieldSingle/internal/maskito/makeZeroShortcutPreprocessor";
import { createYearlessDateSegmentsSteppingPlugin } from "./yearlessDateSegmentsStepping";

const yearlessDatePlaceholderMask = ({
  mode,
  separator = "/",
  placeholder,
  enableStepping = false,
}: {
  mode: YearlessDateMode;
  enableStepping: boolean;
  separator?: string;
  placeholder: string;
}) => {
  const dateOptions = maskitoDateOptionsGenerator({
    mode,
    separator,
  });

  const { plugins, removePlaceholder, ...placeholderOptions } =
    maskitoWithPlaceholder(placeholder);

  const datePlaceholderMask = {
    ...dateOptions,
    plugins: plugins.concat([
      ...(dateOptions.plugins || []),
      ...(enableStepping
        ? [createYearlessDateSegmentsSteppingPlugin({ mode })]
        : []),
    ]),
    preprocessors: [
      ...placeholderOptions.preprocessors,
      ...dateOptions.preprocessors,
      makeZeroShortcutPreprocessor(mode, separator),
    ],
    postprocessors: [
      ...dateOptions.postprocessors,
      ...placeholderOptions.postprocessors,
    ],
  } satisfies Required<MaskitoOptions>;

  const transform = (value: string) => {
    return maskitoTransform(value, datePlaceholderMask);
  };

  return { options: datePlaceholderMask, removePlaceholder, transform };
};

export default yearlessDatePlaceholderMask;
